export default [
  { value: undefined, label: '' },
  { value: 4, label: 'Counter 4' },
  { value: 5, label: 'Counter 5' },
];
